module.exports = __webpack_public_path__ + "static/img/glovis-aa-thumb.063fb2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/glovis-aa-thumb.jpg
// module id = Y163
// module chunks = 0